import { render, staticRenderFns } from "./DinheiroInput.vue?vue&type=template&id=0d76d5c6&"
import script from "./DinheiroInput.vue?vue&type=script&lang=js&"
export * from "./DinheiroInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports